/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCameraX = createReactComponent("camera-x", "IconCameraX", [
  [
    "path",
    {
      d: "M13.5 20h-8.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4",
      key: "svg-0"
    }
  ],
  ["path", { d: "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", key: "svg-1" }],
  ["path", { d: "M22 22l-5 -5", key: "svg-2" }],
  ["path", { d: "M17 22l5 -5", key: "svg-3" }]
]);

export { IconCameraX as default };
//# sourceMappingURL=IconCameraX.js.map
